<template>
    <ul class="wrapper">
        <!-- <router-link :to="{path:`/prizeDetail/1/${item.issueId}`}" tag="li" class="cell_con" v-for="(item,index) of list" :key="index">
            <div class="plan_con">
                <img v-if="item.prizeImg!=''" :src="item.prizeImg" alt="">
                <img v-else src="../../../assets/img/buyDetail/no_pic.png" alt="">

            </div>
            <div class="prize_data">
                <p class="prize_name">{{item.issueName}}</p>
                <div class="prize_rule">
                    <div class="progress_con">
                        <p><van-progress :percentage="item.schedule" :show-pivot="false" color="#FF2323" /></p>
                        <p><span style="float:left">总需<span class="total_text">{{item.total}}</span></span><span style="float:right">剩余<span class="red_text">{{item.Remain}}</span></span></p>
                    </div>
                    <div class="just_now" @click.stop="justNowFn(item.issueId,item.total,item.bought,1)">立即参与</div>
                </div>
            </div>
        </router-link> -->
        <li class="tj_item" v-for="(item,index) of list" :key="index">
           
                <router-link 
                    v-for="(item,index) of item"
                    :key="index"
                    :to="{path:`/prizeDetail/1/${item.issueId}`}" 
                    tag="div"
                    class="tj_items"
                    
                    >
                    <div class="tj_icon">
                        <!-- <img src="../../assets/img/home/oppo.jpg" alt=""> -->
                        <img v-if="item.prizeImg!=''" :src="item.prizeImg" alt="">
                    </div>
                    <p class="prize_name">{{item.issueName.length>10?item.issueName.substring(0,10)+'...':item.issueName}}</p>
                    <!-- <p class="prize_info"><span>余{{item.itemRemainTimes}}</span>/{{item.itemPeotimes}}</p> -->
                    <div class="action_btn">
                        <span @click.stop="justNowFn(item.issueId,item.total,item.bought,1)">参与</span>

                        <!-- <span @click.stop="justNowFn(item[0].issueId,item[0].itemPeotimes,item[0].itemBought,1)">参与</span> -->
                        <!-- <span @click.stop="justNowFn(item[0].issueId,item[0].itemPeotimes,item[0].itemBought,item[0].itemRemainTimes)">包尾</span> -->
                    </div>
                    <div class="tj_line" v-show="index==0"></div>
                </router-link>
                <div class="bottom_line">
                    <p></p>
                </div>
        </li>
    </ul>
</template>
<script>
export default {
    name:'listCell',
    props:{
        list:Array,
        userId:String
    },
    methods:{
        //参与
        justNowFn(i,t,n,j){
            if(this.userId){
                this.$emit('prizeIndex',{
                    id:i,
                    total:t,
                    num:n,
                    joinNum:j
                })
            }else{
                this.$router.push({
                    path:'/loginOrReg'
                })
            }
            
        },
        //to 奖品详情
        toPrizeDetail(k){
            this.$router.push({
                path:'/prizeDetail'
            })
        }
    }
}
</script>
<style scoped>
    .wrapper{
        width: 100%;
        overflow: hidden;
    }
    .bottom_line{
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 2px;
       
    }
    .bottom_line p{
        width: 80%;
        height: 2px;
        margin: 0 auto;
        background: #E7E7E7;
    }
    .tj_item{
        width: 100%;
        height: 311px;
        position: relative;
        overflow: hidden;
    }
    .tj_line{
        width: 2px;
        position: absolute;
        top: 0;
        right: 0;
        height: 220px;
        margin-top: 50px;
        background: #E7E7E7;
    }
    .tj_items{
        /* width: 374px; */
        width: 50%;
        height: 311px;
        position: relative;
        float: left;
    }
    .tj_icon{
        width: 160px;
        height: 160px;
        margin: 15px auto 0;
        text-align: center;
        line-height: 160px;
        position: relative;

    }
    .tj_icon img{
        max-width: 160px;
        max-height: 160px;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        position: absolute;
        margin: auto;
    }

    .prize_name{
        text-align: center;
        font-size: 26px;
        color: #333333;
        margin: 15px 0;
    }
    .prize_info{
        text-align: center;
        font-size: 20px;
        padding-top: 5px;
        color: #9E9E9E;
    }
    .prize_info span{
        color: #C40004;
    }
    .action_btn{
        width: 220px;
        margin: 5px auto 0;
        overflow: hidden;
        display: flex;
        justify-content: center;
    }
    .action_btn span{
        width: 100px;
        height: 50px;
        text-align: center;
        line-height: 50px;
        border-radius: 12px;
        font-size: 26px;
    }
    .action_btn span:nth-child(1){
        float: left;
        background: #FFC016;
        color: #C40004;
    }
     .action_btn span:nth-child(2){
        float: right;
        background: #FF173E;
        color: #fff;
    }
    /* .cell_con{
        padding: 21.5px 23px 21.5px 30px;
        overflow: hidden;
        border-bottom: 1px solid rgb(204, 204, 204);
    }
    .plan_con{
        float: left;
        width: 180px;
        width: 26.5%;
        height: 180px;
        text-align: center;
        line-height: 180px;
        position: relative;
    }
    .plan_con img{
        max-width: 180px;
        max-height: 180px;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        position: absolute;
        margin: auto;
    }

    .prize_data{
        width: 70%;
        height: 180px;
        padding-left: 21px;
        float: left;
    }
    .prize_name{
        width: 100%;
        height: 100px;
        font-size: 28px;
        color: #333;
        overflow: hidden;
    }
    .prize_rule{
        width: 100%;
        height: 77px;
    }
    .progress_con{
        height: 77px;
        float: left;
    }
    .progress_con p:nth-child(1){
        width: 289px;
        height: 12px;
        margin-top: 15px;
    }
    .van-progress{
        height: 12px;
        background: #FFC016;
    }
    .van-progress__portion{
        height: 12px;
    }
    .progress_con p:nth-child(2){
        margin-top: 15px;
        color: #9e9e9e;
        font-size: 23px;
    }

    .just_now{
        float: right;
        width: 167px;
        height: 77px;
        background:rgba(255,192,22,1);
        border-radius:20px;
        color: #CC0006;
        font-size: 30px;
        text-align: center;
        line-height: 77px;
    }
    .red_text{
        color: #E73030;
    } */
</style>



// WEBPACK FOOTER //
// src/views/home/component/listCell.vue